import React from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { navigationConfig, accountMenu } from '@/utils/navigation'
// 导入国际化钩子
import { useTranslation } from '@/i18n'

const Header: React.FC = () => {
  const location = useLocation()
  const navigate = useNavigate()
  // 国际化钩子
  const { t } = useTranslation()

  const getCurrentPageTitle = () => {
    // 特殊处理特定路径
    if (location.pathname === '/production/video/edit') {
      return t('navigation.editVideo')
    } else if (location.pathname === '/feedback') {
      return t('feedback.title')
    } else if (location.pathname === '/pricing') {
      return t('pricing.title')
    }

    // Find the current page title from navigation config
    for (const item of navigationConfig) {
      if (item.path === location.pathname) {
        return t(item.label)
      }
      if (item.children) {
        const child = item.children.find(child => child.path === location.pathname)
        if (child) {
          return t(child.label)
        }
      }
    }

    // Check account menu
    for (const item of accountMenu) {
      if (item.path === location.pathname) {
        return t(item.label)
      }
    }

    return t('navigation.home')
  }

  return (
    <header className="border-b border-gray-800/70">
      <div className="px-6 py-3">
        <div className="flex justify-between items-center">
          <h1 className="text-xl font-bold">{getCurrentPageTitle()}</h1>
          <nav className="flex items-center space-x-6 text-sm">
            <a href="/pricing" className="text-gray-300 hover:text-white transition-colors">
              {t('common.pricing')}
            </a>
            <a href="/feedback" className="text-gray-300 hover:text-white transition-colors">
              {t('common.help')}
            </a>
            <button className="bg-gradient-to-r from-blue-500 to-purple-500 rounded-lg px-4 py-2 font-medium transition-all duration-300 shadow-lg hover:shadow-xl text-white"
              onClick={() => navigate('/production/video/input')}
            >
              {t('common.startCreating')}
            </button>
          </nav>
        </div>
      </div>
    </header>
  )
}

export default Header